<template>
  <InformationBox
    v-if="goodNewsDiscount && goodNewsDiscount.show"
    :type="InformationBoxTypes.SUCCESS"
    title=""
    :description="goodNewsDiscount?.content"
  ></InformationBox>

  <InformationBox
    v-if="!bindSuccessful(quote) && quote?.paymentType === PaymentTypes.PayLater && quote?.paymentDueDate"
    :type="InformationBoxTypes.WARNING"
    :title="
      replaceBookmarks(
        step.formInputs?.confirmationBody?.paymentDuePolicyNotBoundInformationBox?.fields?.title?.value,
        quote,
        feeByMonthResponse,
        dictionary
      )
    "
    :description="step.formInputs?.confirmationBody?.paymentDuePolicyNotBoundInformationBox?.fields?.content?.value"
  ></InformationBox>

  <InformationBox
    v-if="bindSuccessful(quote) && quote?.paymentType === PaymentTypes.PayLater && quote?.paymentDueDate"
    :type="InformationBoxTypes.WARNING"
    :title="
      replaceBookmarks(
        step.formInputs?.confirmationBody?.paymentDuePolicyBoundInformationBox?.fields?.title?.value,
        quote,
        feeByMonthResponse,
        dictionary
      )
    "
    :description="step.formInputs?.confirmationBody?.paymentDuePolicyBoundInformationBox?.fields?.content?.value"
  ></InformationBox>

  <InformationBox
    v-if="firstPayment && firstPayment.show"
    :type="InformationBoxTypes.INFO"
    title=""
    :description="firstPayment.content"
  ></InformationBox>

  <InformationBox
    v-if="annualCreditCardPaymentFailure(quote) && paymentOrBindingFailedContent"
    :type="InformationBoxTypes.WARNING"
    :description="paymentOrBindingFailedContent"
    :links="[
      {
        title: 'Pay now',
        type: LinkTypes.BUTTON_PRIMARY,
        url: makeAPaymentLink,
      },
    ]"
  ></InformationBox>

  <InformationBox
    v-if="
      quote?.paymentFrequency === PaymentFrequency.Annually &&
      quote?.paymentType === PaymentTypes.CreditCard &&
      !bindSuccessful(quote)
    "
    :type="InformationBoxTypes.WARNING"
    :description="step.formInputs?.confirmationBody?.paymentDueNoPaymentInformationBox?.fields?.content?.value"
  ></InformationBox>
  <InformationBox
    v-else-if="annualCreditCardPaymentFailure(quote)"
    :type="InformationBoxTypes.WARNING"
    :description="step.formInputs?.confirmationBody?.paymentFailedSecondaryAnnual?.fields?.label?.value"
  ></InformationBox>

  <div class="border-b my-2 bg-racq-white"></div>

  <Highlights
    :showNumber="true"
    :highlights="highlights"
    :highlightsTitle="step.formInputs?.confirmationBody?.highlightsTitle?.fields?.label?.value"
  >
  </Highlights>

  <SectionPanel
    v-if="
      quote.paymentType === PaymentTypes.PayLater || (annualCreditCardPaymentFailure(quote) && bindSuccessful(quote))
    "
  >
    <template #sectionPanelContent>
      <PanelTitle
        v-bind="
          quote.paymentType === PaymentTypes.PayLater
            ? step.formInputs?.confirmationBody?.paymentMethodsTitle?.fields
            : step.formInputs?.confirmationBody?.paymentMethodsAltTitle?.fields
        "
        class="mb-6"
      />
      <PaymentMethods
        :paymentReferenceNumber="paymentReferenceNumberResult?.content"
        :paymentMethods="step.formInputs?.confirmationBody?.paymentMethods?.fields?.paymentMethods"
        :bpayBillerCode="
          step.formInputs?.confirmationBody?.paymentMethods?.fields?.bpayBillerCode?.fields?.content?.value
        "
        :showAdditionalContent="true"
        :filterPaymentMethods="true"
        :bindSuccessful="(bindSuccessful(quote) as boolean) ?? false"
      ></PaymentMethods>
    </template>
  </SectionPanel>

  <MembershipBenefitsBrands v-if="brandDetails" :step="step" :quote="quote" :brandDetails="brandDetails">
  </MembershipBenefitsBrands>

  <Divider />

  <DecisionIntelligenceCrossSellOffers
    v-if="
      decisionIntelligenceStore.decisionOfferCrossSellResponse?.propositions != null &&
      decisionIntelligenceStore.decisionOfferCrossSellResponse?.propositions.length
    "
    :quote="quote"
    :decisionOffer="decisionIntelligenceStore.decisionOfferCrossSellResponse as IDecisionIntelligenceOfferResponse"
    :stepTitle="step.stepTitle"
  ></DecisionIntelligenceCrossSellOffers>

  <slot name="reviewSummary"></slot>

  <PanelTitle
    v-if="step.formInputs?.confirmationBody.importantInformationTitle?.value"
    :title="step.formInputs?.confirmationBody.importantInformationTitle"
    :subTitle="step.formInputs?.confirmationBody.importantInformation"
  />

  <Divider v-if="step.formInputs?.confirmationBody.importantInformationTitle?.value" />

  <PanelTitle
    v-if="step.formInputs?.confirmationBody.preExistingConditionWaivers?.value"
    :title="step.formInputs?.confirmationBody.preExistingConditionWaiversTitle"
    :subTitle="step.formInputs?.confirmationBody.preExistingConditionWaivers"
  />

  <Divider v-if="step.formInputs?.confirmationBody.preExistingConditionWaivers?.value" />

  <ExpandableContent
    v-if="step.formInputs?.confirmationBody?.additionalExcess"
    id="excesses_details"
    :toggleButtonExpandText="step.formInputs?.confirmationBody?.additionalExcess?.toggleButtonExpandText?.value"
    :toggleButtonCollapseText="step.formInputs?.confirmationBody?.additionalExcess?.toggleButtonCollapseText?.value"
    :dynamicExpander="true"
    class="input-spacing"
  >
    <template #introContent>
      <PanelTitle v-bind="step.formInputs?.confirmationBody?.additionalExcessesTitle?.fields"></PanelTitle>
    </template>
    <template #conditionalContent>
      <AdditionalExcessesHQ
        :fields="step.formInputs?.confirmationBody?.additionalExcesses?.fields"
        :quote="quote"
        :stepId="step.id!"
      />
    </template>
  </ExpandableContent>

  <ExpandableContent
    v-if="step.formInputs?.confirmationBody?.coolingOffPeriod"
    :toggleButtonExpandText="step.formInputs?.confirmationBody?.coolingOffPeriod?.fields?.toggleButtonExpandText?.value"
    :toggleButtonCollapseText="
      step.formInputs?.confirmationBody?.coolingOffPeriod?.fields?.toggleButtonCollapseText?.value
    "
    :dynamicExpander="true"
  >
    <template #introContent>
      <PanelTitle v-bind="step.formInputs?.confirmationBody?.coolingOffPeriodTitle?.fields"></PanelTitle>
    </template>
    <template #conditionalContent>
      <RichText
        :field="{
          value: step.formInputs?.confirmationBody?.coolingOffPeriod?.fields?.conditionalContent?.value,
        }"
        class="richtext"
      />
    </template>
  </ExpandableContent>

  <AccountLoginInfoBox
    v-if="isRegisteredForSelfService && !isAuthenticated"
    :fields="step.formInputs?.confirmationBody?.selfServiceAccountLogin?.fields"
  />
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import { computedAsync } from '@vueuse/core';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import {
  useFormStore,
  IQConfigSettings,
  SettingCategory,
  useConfigSettingsStore,
  useReferenceDataStore,
  useAccountStore,
} from '@/store';
import {
  getPaymentReferenceNumberDetails,
  getPolicyOrReferenceNumber,
  getPaymentReceiptNumber,
  getSummaryPaymentAmount,
  getVisibleReceipt,
  replaceBookmarks,
  getConfirmationHeaderContent,
  getHighlights,
  getFirstPaymentContent,
  getGoodNewsDiscount,
  bindSuccessful,
  Bookmarks,
  paymentSuccessful,
  annualCreditCardPaymentFailure,
} from './confirmation-mapping';
import { useI18n } from 'vue-i18n';
import Highlights from '@/components/Highlights/Highlights.vue';
import { IHighlight } from '@/interfaces/forms/highlights-interface';
import { IFormStep, IQuote } from '@/interfaces';
import { PaymentTypes } from '@/enums/payment-types.enum';
import { PaymentFrequency } from '@/enums/payment-frequency';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import { InformationBoxTypes, LinkTypes } from '@/interfaces/forms/information-box.interface';
import MembershipBenefitsBrands, {
  IBenefitsBrands,
} from '@/components/MembershipBenefitsBrands/MembershipBenefitsBrands.vue';
import { useDecisionIntelligenceStore } from '@/store/decision-intelligence/decision-intelligence.state';
import { IDecisionIntelligenceOfferResponse } from '@/interfaces/decision-intelligence/decision-intelligence-response';
import DecisionIntelligenceCrossSellOffers from '@/components/DecisionIntelligenceCrossSellOffers/DecisionIntelligenceCrossSellOffers.vue';
import ExpandableContent from '@/components/ExpandableContent/ExpandableContent.vue';
import PanelTitle from '../PanelTitle/PanelTitle.vue';
import AccountLoginInfoBox from '@/components/AccountLoginInfoBox/AccountLoginInfoBox.vue';
import AdditionalExcessesHQ from '../AdditionalExcessesHQ/AdditionalExcessesHQ.vue';
import PaymentMethods from '../PaymentMethods/PaymentMethods.vue';
import SectionPanel from '../SectionPanel/SectionPanel.vue';
import Divider from '../Divider/Divider.vue';
import { replaceBookmark } from '@/utils/bookmark.replace';
import { format } from 'date-fns/format';
import { STANDARD_DATE_FORMAT } from '@/constants/formats';

// Define props and emitters
// ------------------------------------------------------------- //
const props = defineProps<{
  step: IFormStep;
  quote: Partial<IQuote>;
}>();

// Define Store
// ------------------------------------------------------------- //
const translation = useI18n();
const formStore = useFormStore();
const configSettingsStore = useConfigSettingsStore();
const referenceDataStore = useReferenceDataStore();
const decisionIntelligenceStore = useDecisionIntelligenceStore();
const accountStore = useAccountStore();

// Define Composables
// ------------------------------------------------------------- //
const confirmationHeaderDetails = ref<any>();

// Define Component state
// ------------------------------------------------------------- //

const showFailedAnnualPayment = computed(() => {
  return (
    props.quote.paymentType === PaymentTypes.CreditCard &&
    props.quote.paymentFrequency === PaymentFrequency.Annually &&
    !getVisibleReceipt(props.quote)
  );
});

const makeAPaymentLink = computed(() => {
  return `${props.step.formInputs?.confirmationBody?.makeAPaymentLink?.value?.href}?${replaceBookmark(Bookmarks.paymentReferenceNumber, props.step.formInputs?.confirmationBody?.makeAPaymentLink?.value?.querystring, props.quote?.paymentReferenceNumber ?? '')}`;
});

const isAuthenticated = computedAsync(async () => {
  return await accountStore.isAuthenticated;
});

const isRegisteredForSelfService = computed(() => {
  return props.quote.primaryPolicyHolderDetails?.ruleCalculations?.isRegisteredForSelfService?.value;
});

const enablePurchaseEmail = ref(false);
const enableQuoteEmail = ref(false);
const isHomeAutoRenewalPreferenceEnabled = ref(false);
const summaryPaymentAmount = ref('');
const policyOrReferenceNumber = ref('');
const receiptNumber = ref('');
const paymentReferenceNumberResult = ref<any>();

const highlights = ref<IHighlight[]>([]);
const brandDetails = ref<IBenefitsBrands>();
const paymentOrBindingFailedContent = ref<string>('');
const dictionary: Record<string, string> = translation.getLocaleMessage('en') as any;
const feeByMonthResponse = ref<number>(0);

const goodNewsDiscount = ref<any>();
const firstPayment = ref<any>();

// Lifecycle hooks
// ------------------------------------------------------------- //
onMounted(async () => {
  formStore.setFormCompleted();
  // https://jira.racqgroup.local/browse/PSR-626
  // Done button disabled on previous iq payment step, need to reenable it.
  formStore.disableAllSteps = false;

  const insuranceStartDate = props.quote.insuranceStartDate?.value ?? undefined;
  const quotingFeesResponse = insuranceStartDate
    ? await referenceDataStore.getQuotingFeesPayByMonth(new Date(insuranceStartDate))
    : undefined;

  feeByMonthResponse.value = (quotingFeesResponse.value.payByTheMonthFee ?? 0) * 12;

  confirmationHeaderDetails.value = getConfirmationHeaderContent(
    props.step,
    props.quote,
    feeByMonthResponse.value,
    dictionary
  );

  goodNewsDiscount.value = getGoodNewsDiscount(props.step, props.quote, feeByMonthResponse.value, dictionary);
  firstPayment.value = getFirstPaymentContent(props.step, props.quote);

  enablePurchaseEmail.value = (await configSettingsStore.getSetting(
    IQConfigSettings.EnablePurchaseEmail,
    SettingCategory.IQSettings
  )) as boolean;
  enableQuoteEmail.value = (await configSettingsStore.getSetting(
    IQConfigSettings.EnableQuoteEmail,
    SettingCategory.IQSettings
  )) as boolean;
  isHomeAutoRenewalPreferenceEnabled.value = (await configSettingsStore.getSetting(
    IQConfigSettings.IsHomeAutoRenewalPreferenceEnabled,
    SettingCategory.IQSettings
  )) as boolean;
  await decisionIntelligenceStore.getDecisionOffer(true, false);

  summaryPaymentAmount.value = getSummaryPaymentAmount(props.step, props.quote, feeByMonthResponse.value, dictionary);

  policyOrReferenceNumber.value = getPolicyOrReferenceNumber(props.step, props.quote);
  paymentReferenceNumberResult.value = getPaymentReferenceNumberDetails(props.step, props.quote);
  receiptNumber.value = getPaymentReceiptNumber(props.step, props.quote);

  highlights.value = getHighlights(props.step, props.quote, isHomeAutoRenewalPreferenceEnabled.value);

  if (props.step.formInputs?.confirmationBody?.brandBenefits) {
    brandDetails.value = {
      brands: props.step.formInputs?.confirmationBody?.brandBenefits?.fields?.brands,
      benefitsLink: props.step.formInputs?.confirmationBody?.brandBenefits?.fields?.benefitsLink?.value,
      title: props.step.formInputs?.confirmationBody?.brandBenefits?.fields?.title?.value,
      subTitle: props.step.formInputs?.confirmationBody?.brandBenefits?.fields?.subTitle?.value,
      moreOffersText: props.step.formInputs?.confirmationBody?.brandBenefits?.fields?.moreOffersText?.value,
    };
  }

  if (showFailedAnnualPayment.value) {
    if (props.quote.policyReference) {
      paymentOrBindingFailedContent.value = replaceBookmark(
        Bookmarks.dueDate,
        props.step.formInputs?.confirmationBody?.paymentFailedAnnual?.fields?.label?.value ?? '',
        props.quote?.paymentDueDate ? format(new Date(props.quote.paymentDueDate), STANDARD_DATE_FORMAT) : ''
      );
      paymentOrBindingFailedContent.value = replaceBookmark(
        Bookmarks.paymentReferenceNumber,
        paymentOrBindingFailedContent.value ?? '',
        props.quote.paymentReferenceNumber ?? ''
      );
    }
  }
});
</script>
